import { Observable } from 'rxjs/Observable';
import { AuthService } from './../../shared/models/auth.service';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';

@Injectable()
export class AdminDashboardService {
  constructor(private authService: AuthService, private http: Http) { }

  public GetVehicleLocation(): Observable<IAPIResponse> {
    // let getUpcomingBookingUrl = WeGoConfig.API_GET_UPCOMING_BOOKING_LIST;
    // let queryString = this.authService.HandleAPIListInput(input);
    // if (queryString) {
    //   getUpcomingBookingUrl = getUpcomingBookingUrl + "?" + queryString;
    // }
    // let headers = this.authService.GetHeader();
    // let options = new RequestOptions({ headers: headers });
    // return this.http.get(getUpcomingBookingUrl, options)
    //   .map(this.authService.HandleAPIResponse)
    //   .catch(this.authService.HandleAPIError);

    let tt: IAPIResponse = {
      "data": [
        {
          "vehicleMasterHashId": "Test",
          "licenceTag": "AA-BB-01",
          "vehicleStatus": "Available",
          "homeLocation": {
            "latitude": -33.91747,
            "longitude": 151.22912
          },
          "currentLocation": {
            "latitude": -33.91910,
            "longitude": 151.22907
          }
        },
        {
          "vehicleMasterHashId": "Test",
          "licenceTag": "AA-BB-02",
          "vehicleStatus": "Unavailable",
          "homeLocation": {
            "latitude": -33.658452,
            "longitude": 151.7851212
          },
          "currentLocation": {
            "latitude": -33.985241,
            "longitude": 151.23255
          }
        },
        {
          "vehicleMasterHashId": "Test",
          "licenceTag": "AA-BB-03",
          "vehicleStatus": "Priority1",
          "homeLocation": {
            "latitude": -33.987722,
            "longitude": 151.714452
          },
          "currentLocation": {
            "latitude": -33.111022,
            "longitude": 151.322554
          }
        }
      ],
      "error": "",
      "totalRecords": 0,
      "status": {
        "dateTimeUTC": "23-05-2017 05:17",
        "version": "1.0.0.0",
        "isSpecialBookingExist": false
      }
    };

    return Observable.create((observer: any) => {
      observer.next(tt);
      observer.complete();
    });
  }

  public GetVehicleWithStatus(instanceHashId: string, companyHashId: string, svgHashId: string): Observable<IAPIResponse> {
    let getVehicleUrl = WeGoConfig.API_GET_VEHICLE_WITH_STATUS;

    getVehicleUrl = getVehicleUrl + "?instanceHashId=" + instanceHashId
      + "&companyHashId=" + companyHashId
      + "&svgHashId=" + svgHashId;

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getVehicleUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetWindowsServiceStatus(): Observable<IAPIResponse> {
    let getWindowsServiceStatusUrl = WeGoConfig.API_GET_WINDOWS_SERVICE_STATUS;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getWindowsServiceStatusUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetPaymentServiceStatus(): Observable<IAPIResponse> {
    let getWindowsServiceStatusUrl = WeGoConfig.API_GET_ONLINE_PAYMENT_SERVICE_STATUS;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getWindowsServiceStatusUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetPriorityForIssues(instantHashId?: string): Observable<IAPIResponse> {
    let getUrl = WeGoConfig.API_GET_PRIORITY_FOR_ISSUE + "?instanceHashId=" + instantHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetSharedVehicleGroupList(companyHashId?: string, instanceHashId?: string): Observable<IAPIResponse> {
    let getSVGUrl = WeGoConfig.API_GET_SHAREDVEHICLEGROUP_DETAIL;

    getSVGUrl = getSVGUrl + "?";
    if (companyHashId) {
      getSVGUrl = getSVGUrl + "&companyHashId=" + companyHashId;
    }
    if (instanceHashId) {
      getSVGUrl = getSVGUrl + "&instanceHashId=" + instanceHashId;
    }

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getSVGUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportVehicleWithStatusXls(instanceHashId: string, companyHashId: string, svgHashId: string): any {
    let getUrl = WeGoConfig.API_EXPORT_VEHICLE_WITH_STATUS_XLS;

    getUrl = getUrl + "?instanceHashId=" + instanceHashId
      + "&companyHashId=" + companyHashId
      + "&svgHashId=" + svgHashId;

    let headers = this.authService.GetHeader('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
    let options = new RequestOptions({ headers: headers, responseType: ResponseContentType.Blob });
    return this.http.get(getUrl, options);


  }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/dashboard/models/admin-dashboard.service.ts